import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export const shadowDomTestId = 'activity_feed-shadow_host'

/**
 * Used to render elements within the ShadowDOM
 */
export const ShadowDOM: FC<PropsWithChildren> = ({ children }) => {
  const shadowHostRef = useRef<HTMLDivElement>(null)
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | undefined>()

  useEffect(() => {
    // Do not try to attach a shadow dom if it was already attached, that throws an error
    if (shadowHostRef.current?.shadowRoot) return
    const rootElement = shadowHostRef.current?.attachShadow({ mode: 'open' })
    setShadowRoot(rootElement)
  }, [shadowRoot])

  return (
    <div data-testid={shadowDomTestId} ref={shadowHostRef}>
      {shadowRoot ? createPortal(children, shadowRoot as unknown as Element) : null}
    </div>
  )
}
